import dayjs from 'dayjs'

import type { GetUserPaymentMethodsResponse } from '@fourthwall/services/dist/PaymentApiClient'

const formatMonth = (month: string) =>
  dayjs()
    .month(parseInt(month) - 1)
    .format('MM')

const formatYear = (year: string) => dayjs().year(parseInt(year)).format('YY')

export const formatExpiresAt = (
  expires: Extract<GetUserPaymentMethodsResponse[number]['details'], { type: 'CARD' }>['expiresAt'],
) => {
  return `${formatMonth(expires.month)}/${formatYear(expires.year)}`
}
